import * as busyCounter from '../../../../sharedmodules/action-creators/busy-counter';
import actions from '../../../../sharedmodules/actions-list';
import { handleError } from '../../../../sharedmodules/services/error-handlers';
import { searchPinTransferMapping } from '../repositories/searchPinTransferMapping';

export const searchPinTransferData = (getAccessToken, data) => async (dispatch) => {

    dispatch(busyCounter.increaseBusyCounter());

    try {

        const userDealerMappedData = await searchPinTransferMapping(getAccessToken, data);
        dispatch({
            data: userDealerMappedData,
            type: actions.GET_DEALER_PIN_TRANSFER_DATA,

        });

    } catch (error) {

        handleError(error);

    } finally {

        dispatch(busyCounter.decreaseBusyCounter());

    }

};
